import { createTheme } from '@mui/material/styles';
// Colors
const BLUE_GRAY = '#607d8b';
const VERTICE_RED = "#CF372C";
let theme = createTheme({
    typography: {
        fontFamily: 'roboto',
        h1: {
            fontSize: '2rem',
            fontWeight: 700,
        },
        h2: {
            fontSize: '1.5rem',
            fontWeight: 600,
        },
        h4: {
            fontSize: "34px",
            fontWeight: 400,
            lineHeight: "41.99px",
            letterSpacing: "0.25px",
            wordWrap: 'break-word'
        },
        h5: {
            fontSize: "24px",
            fontWeight: 400,
            lineHeight: "32.02px",
            wordWrap: 'break-word'
        },
        h6: {
            fontSize: "18px",
            fontWeight: 400,
            lineHeight: "24.02px",
            wordWrap: 'break-word'
        },
        body1: {
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
            letterSpacing: "0.15px",
            wordWrap: 'break-word'
        },
        body2: {
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20.02px",
            letterSpacing: "0.17px",
            wordWrap: 'break-word'
        },
        inputValue: {
            fontSize: "16px",
            fontWeight: '400',
            lineHeight: "24px",
            letterSpacing: "0.15px",
            wordWrap: 'break-word'
        },
        inputLabel: {
            fontSize: "12px",
            fontWeight: '400',
            lineHeight: "12px",
            letterSpacing: "0.15px",
            wordWrap: 'break-word',
            color: 'blueGray'
        },
        inputHelper: {
            fontSize: "12px",
            fontWeight: '400',
            lineHeight: "19.92px",
            letterSpacing: "0.40px",
            wordWrap: 'break-word'
        },
        buttonSmall: {
            fontSize: "13px",
            fontWeight: '500',
            textTransform: 'uppercase',
            lineHeight: "22px",
            letterSpacing: "0.46px",
            wordWrap: 'break-word'
        },
        buttonLarge: {
            fontSize: "15px",
            fontWeight: '500',
            textTransform: 'uppercase',
            lineHeight: "26px",
            letterSpacing: "0.46px",
            wordWrap: 'break-word'
        }
    },
    palette: {
        primary: {
            main: VERTICE_RED,
        },
        secondary: {
            main: '#dc004e',
        },
        background: {
            default: '#f5f5f5',
        },
        text: {
            primary: '#000000',
            secondary: '#000000',
        },
    },
    components: {
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: BLUE_GRAY,
                }
            }
        }
    }
});
theme = createTheme(theme, {
    palette: {
        blueGray: theme.palette.augmentColor({
            color: {
                main: BLUE_GRAY,
                '50': '#ECEFF1'
            },
            name: 'blueGray',
        }),
    }
});
export default theme;
